export default __webpack_public_path__ + "assets/spreadsheet2.2bbe213f.gif";